import React, { useState, useEffect } from "react";
import { LiaArrowUpSolid } from "react-icons/lia";
import "../../assets/css/Services.css";
import { toast } from "react-toastify";

const MainServies = ({ apiData }) => {
    const [data, setData] = useState(null);


    const placeholderData = {
        image: "placeholder-main.jpg",
        client_image: "placeholder-client.jpg",
        title: "GLYPH Website",
        sub_title: "GLYPH Website",
        link: "#",
        date: "2024-01-01",
        desc: "This is a description Page for GLYPH Website.",
        images: [
            { id: 1, image: "placeholder-image1.jpg" },
            { id: 2, image: "placeholder-image2.jpg" },
        ],
    };

    useEffect(() => {
        if (apiData && apiData.length > 0) {
            toast.success("Updating data with new apiData:", apiData[0]);
            setData(apiData[0]);
        } else {
            toast.success("Using placeholder data.");
            setData(placeholderData);
        }
    }, [apiData]);

    if (!data) {
        return null;
    }

    return (
        <section className="section1_hammad">
            <div className="section_container_hammad d-flex justify-content-center">
                <div className="row w-100">
                    <div className="col-md-12 image_container_hammad">
                        <img
                            src={`https://api.glyphqai.com/uploads/subservices/${data.image}`}
                            alt="Main Image"
                            className="img-fluid w-100"
                            id="hammad-img"
                        />
                        <div className="card_wrapper_hammad" id="cardWrapperHammad">
                            {data.images &&
                                data.images.map((img) => (
                                    <div key={img.id} className="card_hammad me-3 py-2">
                                        <img
                                            src={`https://api.glyphqai.com/uploads/subservices/${data.client_image}`}
                                            alt="Client Image"
                                            className="img-fluid"
                                        />
                                        <div className="big_card_hammad p-1 py-2">
                                            <div className="small_card_hammad p-1 py-2">
                                                <img
                                                    src={`https://api.glyphqai.com/uploads/subservices/${img.image}`}
                                                    alt=""
                                                    className="img-fluid"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            <div className="" style={{ height: 200 }}>
                                <h2 className="neon-text ms-3 ">{data.title}</h2>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 text_row_hammad text-white">
                        <div className="top_bar_hammad">
                            <a
                                className="gradient-text text-decoration-none text-white fs-4"
                                href={data.link}
                            >
                                <LiaArrowUpSolid size={35} className="arrow" />
                                {data.title}
                            </a>
                            <div className="fs-md-4 fs-5 invert_text">
                                <span className="invert_text">{data.title + " "}Expert</span>&nbsp;
                                <span className="invert_text"> •• </span>&nbsp;
                                <span className="invert_text">{new Date().getFullYear()}</span>
                            </div>
                        </div>
                        <div className="content_section_hammad">
                            <div className="description_hammad">
                                <p className="fs-4 fs-md-5 invert_text">{data.desc}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MainServies;
